import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const SupportPopoverSection = styled(FlexColumn)`
  gap: var(--spacing-2);
  width: 230px;
  padding: var(--spacing-8);
  border-bottom: 1px solid ${themeStyle.varInkSuperLight};

  &:last-child {
    border-bottom: none;
  }
`;
